/* eslint-disable camelcase */
export default {
	scheduleButtonText: "Schedule",
	oneTimeMeetingOptionText: "New one-time meeting",
	recurringMeetingOptionText: "New recurring meeting",
	manageScheduleOptionText: "Manage schedule",
};
